import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/Stores";
import { useMsTeamsInMeetingApps } from "./hooks/hooks";
import msTeamsMeetingAppFrameEnum from "./enum/msTeamsMeetingAppFrameEnum";
import DuringMeeting from "./stages/DuringMeeting";
import BeforeMeeting from "./stages/BeforeMeeting";
import InMeetingAppConfig from "./stages/InMeetingAppConfig";
import { constants } from "../shared/constants";

const InMeetingApp: React.FC = observer(() => {
    const inMeetingAppContext = useMsTeamsInMeetingApps();
    const { inMeetingAppStore } = useStore();

    useEffect(() => {
        if (inMeetingAppContext.meetingId !== "") {
            inMeetingAppStore.getParticipantData(inMeetingAppContext.meetingId);
            inMeetingAppStore.getUserStatus(inMeetingAppContext.meetingId);
        }
    }, [inMeetingAppContext.meetingId, inMeetingAppStore]);

    useEffect(() => {
        if (inMeetingAppContext.meetingId !== "") {
            const interval = setInterval(() => {
                inMeetingAppStore.getUserStatus(inMeetingAppContext.meetingId);
            }, constants.getUserStatusInterval);
            return () => clearInterval(interval);
        }
    }, [inMeetingAppContext.meetingId, inMeetingAppStore]);

    const renderContent = () => {
        switch (inMeetingAppContext.meetingStage) {
            case msTeamsMeetingAppFrameEnum.settings:
                return <InMeetingAppConfig />;
            case msTeamsMeetingAppFrameEnum.duringMeeting:
                return (
                    <DuringMeeting
                        role={inMeetingAppStore.participantData.role}
                        userStatus={inMeetingAppStore.userStatus}
                    />
                );
            default:
                return (
                    <BeforeMeeting
                        role={inMeetingAppStore.participantData.role}
                        userStatus={inMeetingAppStore.userStatus}
                    />
                );
        }
    };

    return renderContent();
});

export default InMeetingApp;
